import React from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

const PieChartByType = ({ data }) => {
  // Prepare data: count incidents by type
  const incidentCounts = data.reduce((acc, { type }) => {
    acc[type] = (acc[type] || 0) + 1;
    return acc;
  }, {});

  const chartData = Object.entries(incidentCounts).map(([type, count]) => ({
    type,
    count,
  }));

  const COLORS = [
    "#8884d8", "#82ca9d", "#ffc658", "#ff8042", "#d45087",
    "#a05195", "#ff6361", "#58508d", "#003f5c", "#bc5090"
  ];

  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={chartData}
          dataKey="count"
          nameKey="type"
          cx="50%"
          cy="50%"
          outerRadius={100}
          fill="#8884d8"
          label={({ name, value }) => `${name}: ${value}`}
        >
          {chartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default PieChartByType;
